module.exports = __webpack_public_path__ + "img/20180515110330.8038baaf.jpg";